import UsersPageContent from "../components/Users/UsersPageContent";

const AdminUsers = () => {
  return <UsersPageContent type="admin" />;
};

export default AdminUsers;
